export default __webpack_public_path__ + "static/media/polygonLogo.15243ff1.svg";